import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { BottomNavigation, Card, PageModal, Typography, Button } from '@otp/ui';
import clsx from 'clsx';
import { ReactComponent as LeftDecor } from './otp-decor.svg';
import { Arrow } from '@otp/icons';
import { Routes } from 'src/components/common/router/constants';
import { useNavigate } from 'react-router-dom';

import { useNotifications } from '@otp/ui';
import { useMutation } from '@apollo/client';
import { TermsAndConditionsContent } from 'src/components/onboarding/terms-and-conditions-content';
import { useAuthContext } from 'src/context/auth.context';
import { usePrograms } from 'src/hooks/query/use-programs';
import {
  AppArea,
  UserAssignProgramDocument,
  CurrentUserDocument,
} from 'src/graphql/generated/graphql';
import { Subjects } from 'src/graphql/generated/graphql';
import { Actions } from 'src/graphql/generated/graphql';
import { useCan } from 'src/utils/can';

export const ProgramOptIn = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { programs, loading: isProgramsLoading } = usePrograms();
  const [showTS, setShowTS] = useState(false);
  const notifications = useNotifications();
  const { loadUser } = useAuthContext();
  const { can } = useCan();

  const availableUserProgram = programs.find((program) => {
    return can({
      action: Actions.Assign,
      subject: Subjects.Program,
      appArea: AppArea.Lms,
      data: { id: program.id },
    });
  });

  const onCloseTS = () => setShowTS(false);

  const [assignUserProgram, { loading: isLoading }] = useMutation(
    UserAssignProgramDocument,
    {
      refetchQueries: [CurrentUserDocument],
    },
  );

  const joinProgram = async () => {
    if (!availableUserProgram) {
      return;
    }

    await assignUserProgram({
      variables: {
        data: {
          programId: availableUserProgram.id,
        },
      },
    });
    await loadUser();

    notifications.show(t('onboarding.program-assigned-successfully'));
    navigate(`${Routes.editProfile.path}?postRedirect=lmsCurriculums`);
  };

  return (
    <div className="mt-4">
      <Card
        className={clsx(
          'bg-[#F8B92A] relative overflow-hidden',
          'flex p-0 w-full h-[217px]',
        )}
      >
        <div className="h-full">
          <LeftDecor />
        </div>

        <div className="flex flex-col w-full justify-center p-6 mx-auto">
          <Typography
            fontWeight="bold"
            className="whitespace-pre-line mb-6"
            variant="h6"
          >
            {t('my-organisation.program-opt-in.card.title')}
          </Typography>
          <Card
            noBorder
            className="bg-[#1C1F21] text-white px-4 py-1.5 inline-flex items-center justify-between rounded-xl w-full min-h-[45px] md:w-[280px]"
            onClick={() => {
              setShowTS(true);
            }}
          >
            <Typography
              variant="body1"
              className="text-base max-[445px]:text-[10px] leading-none"
            >
              {t('my-organisation.program-opt-in.card.cta')}
            </Typography>
            <span className="text-sm">+</span>
          </Card>
        </div>
      </Card>

      {showTS && (
        <PageModal
          open
          onClose={onCloseTS}
          title="OTP Mobile App - Terms of Use"
        >
          <TermsAndConditionsContent />
          <BottomNavigation>
            <Button variant="outlined" className="grow" onClick={onCloseTS}>
              <Arrow /> &nbsp; {t('common.cancel')}
            </Button>
            <Button
              type="submit"
              variant="contained"
              className="grow"
              disabled={isLoading}
              onClick={joinProgram}
            >
              {t('common.agree')}
            </Button>
          </BottomNavigation>
        </PageModal>
      )}
    </div>
  );
};
